<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="تقرير الترقيات"
      :stringifyLongNum="true"
      :fetch="fetchData"
      :fields="json_fields"
      :header="[
        name,
        desc,
        `كشف بأسماء الموظفين المرشحين للترقية للدرجة ${gradeString} و ${aboveGradeString} الذين انهو الحد الأدنى في درجاتهم الوظيفية عن شهر ${convert_Month(
          month
        )}`,
      ]"
    >
      <!-- :header="[name, desc, `تقرير الترقيات ${convert_Month(month)}`]" -->
      <!-- :footer="footerArray" -->
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  props: [
    "name",
    "desc",
    "month",
    "grade",
    "aboveGrade",
    "gradeString",
    "aboveGradeString",
  ],
  data() {
    return {
      json_fields: {
        "ر.ت": "num",
        "رقم الملف الشخصى": "profileNumber",
        الإسم: "employeeName",
        "الوضع الوظيفي": "jobType",
        "تاريخ التوظيف": {
          callback: (value) => {
            return this.convert_excel(value.jobDate);
          },
        },
        "المؤهل العلمي": "scientificAppointment",
        التخصص: "specialization",
        "الدرجة الحالية": "currentGrade",
        "تاريخ الحصول عليها": {
          callback: (value) => {
            return this.convert_excel(value.lastGradeUpdate);
          },
        },
        "شهر العلاوة": "monthName",
        "الدرجة المرقة لها": "dueGrade",
        "تاريخ استحقاقها": {
          callback: (value) => {
            return this.convert_excel(value.monthDate);
          },
        },
        "الكفاءة الوظيفية لسنة 2019": "efficiency",
        "الكفاءة الوظيفية لسنة 2020": "efficiencyTwo",
        "الكفاءة الوظيفية لسنة 2021": "efficiencyThree",
      },
    };
  },
  methods: {
    async fetchData() {
      if (this.month == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال من تاريخ الشهر"
        );
      }
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(
        `${env.HR()}/api/hr/employeesReport/GetCareerPromotion?MonthDate=${
          this.month
        }&Grade=${this.grade}&AboveGrade=${this.aboveGrade}`,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      res.data.data.items.forEach((item, i) => {
        item.num = i + 1;
      });

      return res.data.data.items;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },
    convert_excel(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return `${d.getFullYear()} - ${d.getMonth() + 1} - ${d.getDate()}`;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped></style>
